/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type FeatureFlagApiResourceMode = typeof FeatureFlagApiResourceMode[keyof typeof FeatureFlagApiResourceMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlagApiResourceMode = {
  test: 'test',
  full: 'full',
} as const;
